<template>
  <div>
    <table class="table table-bordered">
      <tr>
        <th style="text-align: center">
          <span>Người tạo</span>
        </th>
        <th>Bài viết</th>
        <th style="text-align: center">Người sửa</th>
        <th style="text-align: center">Thao tác</th>
        <th style="text-align: center">Xem</th>
      </tr>
      <tr v-for="(item, index) in listEntry" :key="`${item.id}_${index}`">
        <td style="text-align: center">
          {{item.userName || 'Chưa xác định'}}
        </td>
        <td>
          <div class="row">
            <div class="col-md-10">
              <router-link :to="{ path: '/entry/history', query: { new_id: item.id }}">
                <p><b>{{item.title}}</b></p>
              </router-link>
            </div>
          </div>
        </td>
        <td style="text-align: center">
          <p>{{item.userChange}}</p>
          <p>{{item.timeString}}</p>
        </td>
        <td style="text-align: center">
          {{item.statusStr || 'Chưa xác định'}}
        </td>
        <td style="text-align: center">
          <b-button @click="onSelectedPreview(item)" v-b-modal.modal-preview-new variant="outline-danger">Xem</b-button>
        </td>
      </tr>
    </table>

    <div v-if="loadingPage" style="text-align: center">
      <br />
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
      <br />
    </div>

    <!-- Modal - Preview -->
    <b-modal hide-footer style="max-width: 1000px" id="modal-preview-new" title="Nội dung bài viết">
      <h3><b>{{entryPreview.title}}</b></h3>
      <br />
      <div v-html="entryPreview.content" />
    </b-modal>

    <div class="mt-3">
      <h6 class="text-center">Chọn Trang</h6>
      <b-pagination @change="onchangePage" v-model="currentPage" :per-page="20" :total-rows="totalElements" align="fill"></b-pagination>
    </div>
  </div>
</template>

<script>
import {GET_HISTORY_ENTRY_PAGE} from "@/store/new.module";

export default {
  name: "History",
  data() {
    return {
      listEntry: [],
      loadingPage: false,
      currentPage: 0,
      totalElements: 0,
      entryPreview: {},
    }
  },
  mounted() {
    this.loadingPage = true;
    this.$store.dispatch(GET_HISTORY_ENTRY_PAGE, {pageNumber: this.currentPage - 1, pageSize: 20}).then(({data}) => {
      this.totalElements = data.totalElements;
      this.listEntry = data.content.map((item) => {
        const _data = JSON.parse(item.data);
        const userChange = item.user.displayName || 'Chưa xác định';
        const timeString = (new Date(item.regDate)).toLocaleString();
        item = {..._data, userChange, timeString };
        return item;
      });
      this.loadingPage = false;
    });
  },
  methods: {
    onSelectedPreview(item) {
      this.entryPreview = item;
    },
    onchangePage(pageIndex) {
      this.loadingPage = true;
      this.$store.dispatch(GET_HISTORY_ENTRY_PAGE, {pageNumber: pageIndex, pageSize: 20}).then(({data}) => {
        this.totalElements = data.totalElements;
        this.loadingPage = false;
        this.listEntry = data.content.map((item) => {
          const _data = JSON.parse(item.data);
          const userChange = item.user.displayName || 'Chưa xác định';
          const timeString = (new Date(item.regDate)).toLocaleString();
          item = {..._data, userChange, timeString };
          return item;
        });
      });
    },
  }
}
</script>

<style>
.modal-dialog.modal-md {
  max-width: 735px;
}

.modal-dialog.modal-md img {
  width: 100%;
  height: 100%;
}
</style>
